import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { PAYMENTS_DASHBOARD_FEATURE_GROUP } from './group';

export const PAYMENTS_DASHBOARD_FEATURES = {
  READ: {
    guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f0700',
    name: 'payments_dashboard:read',
    description: 'View the payments dashboard and its widget data',
    action: 'read',
    product: 'payments',
    parentGuid: PAYMENTS_DASHBOARD_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { PAYMENTS_DASHBOARD_FEATURE_GROUP } from './group';

export const PAYMENTS_DASHBOARD_MODULE: FeatureModule = {
  product: 'payments',
  groups: [PAYMENTS_DASHBOARD_FEATURE_GROUP],
  features: featureList(PAYMENTS_DASHBOARD_FEATURES),
};
